/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function CustomerTableConfig($translate, $mdDialog, $document, $state, toast, types, utils, userService, customerService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(/*params*/) {
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.customer,

            tableTitle: $translate.instant('customer.customers'),

            columns: [
                { key: 'createdTime',
                  title: 'entity.createdTime'},
                { key: 'title',
                  title: 'customer.title'},
                { key: 'customerSubscriptionName',
                  title: 'subscription.subscription'},
                { key: 'country',
                  title: 'contact.country'},
                { key: 'city',
                  title: 'contact.city'},
                { key: 'subCustomersCount',
                  title: 'customer.subCustomers-count'},
                { key: 'gatewaysCount',
                  title: 'customer.gateways-count'},
                { key: 'devicesCount',
                  title: 'customer.devices-count'}
            ],

            loadEntities: () => {return customerService.getCustomers()},
            loadEntity: (entityId) => {return customerService.getCustomer(entityId)},
            saveEntity: (entity) => {return customerService.saveCustomer(entity)},
            deleteEntity: (entityId) => {return customerService.deleteCustomer(entityId)},

            manageGateways: (event, entity) => {
                manageGateways(event, entity);
            },

            manageUsers: (event, entity) => {
                manageUsers(event, entity);
            },

            actionCellDescriptors: [
                {
                    name: 'customer.manage-gateways',
                    icon: 'router',
                    isEnabled: () => {
                        return true;
                    },
                    onAction: ($event, entity) => {
                        manageGateways($event, entity);
                    }
                },
                {
                    name: 'customer.manage-users',
                    icon: 'account_circle',
                    isEnabled: () => {
                        return true;
                    },
                    onAction: ($event, entity) => {
                        manageUsers($event, entity);
                    }
                }
            ],
            addEnabled: () => {
                return access == types.access.admin;
            },
            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('customer.delete-customer-title', {title: entity.title});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('customer.delete-customer-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('customer.delete-customers-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('customer.delete-customers-text');
            }

        };

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function manageUsers($event, customer) {
        if ($event) {
            $event.stopPropagation();
        }
        $state.go('home.customers.users', {customerId: customer.id.id});
    }

    function manageGateways($event, customer) {
        if ($event) {
            $event.stopPropagation();
        }
        $state.go('home.customers.gatewayGroups', {customerId: customer.id.id});
    }

}



// WEBPACK FOOTER //
// ./src/app/customer/customer-table.config.js